import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, formValueSelector, getFormMeta, getFormInitialValues } from 'redux-form';

import { PortalForm } from './PortalForm';
import { ClippingPlatformState } from 'store/clippingPlatformState';
import { PortalFormComponentProps, FormValuesFields, StateToProps } from './PortalForm.types';

export const useColorField = 'useColor';
export const useSocialMessagingTextField = 'useSocialMessagingText';
export const virtualGraduationSectionToggleField = 'virtualGraduationSectionToggle';
export const socialMessagingText = 'socialMessagingText';
export const virtualGraduationMessageField = 'virtualGraduationMessage';
export const virtualGraduationVideoField = 'virtualGraduationVideo';
export const customContentSectionToggleField = 'customContentSectionToggle';
export const customContentTextField = 'customContentText';
export const announcementSectionToggleField = 'announcementSectionToggle';
export const announcementMessageField = 'announcementMessage';

export const mapStateToProps = (state: ClippingPlatformState, { form }: { form: string }): StateToProps => ({
  useColor: formValueSelector(form)(state, useColorField),
  useSocialMessagingText: formValueSelector(form)(state, useSocialMessagingTextField),
  virtualGraduationSectionToggle: formValueSelector(form)(state, virtualGraduationSectionToggleField),
  virtualGraduationMessage: formValueSelector(form)(state, virtualGraduationMessageField),
  formMeta: getFormMeta(form)(state),
  customContentSectionToggle: formValueSelector(form)(state, customContentSectionToggleField),
  customContentText: formValueSelector(form)(state, customContentTextField),
  announcementSectionToggle: formValueSelector(form)(state, announcementSectionToggleField),
  formInitialValues: getFormInitialValues(form)(state) as FormValuesFields,
  announcementMessage: formValueSelector(form)(state, announcementMessageField),
});

export const PortalFormContainer = compose<any>(
  connect(mapStateToProps, null),
  reduxForm<FormValuesFields, PortalFormComponentProps>({
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  }),
)(PortalForm);
